/* Rebuy owns cart mutations; this bridge only reads Shopify-rendered header markup.
 * https://developers.rebuyengine.com/reference/cart-event-listeners/
 * https://shopify.dev/docs/api/ajax/section-rendering
 */
(function () {
  'use strict';
  function createBridge({ document, fetch, DOMParser, location, cartURL, setTimeout, clearTimeout, AbortController, delay = 80, window, getCart = () => window?.Rebuy?.Cart }) {
    const events = ['rebuy:cart.ready', 'rebuy:cart.change', 'rebuy:cart.enriched', 'rebuy:smartcart.hide'];
    let version = 0, timer, controller, active = true, listening = false, restoring = false;
    function url() {
      const target = new URL(cartURL, location.href);
      if (target.origin !== new URL(location.href).origin) throw Error('Cart section must be same-origin');
      target.search = '';
      target.searchParams.set('sections', 'cart-icon-bubble');
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) target.searchParams.set('preview_theme_id', preview);
      return target.href;
    }
    async function render(requestVersion) {
      if (!active || !document.querySelector('#cart-icon-bubble')) return;
      controller?.abort();
      const request = new AbortController();
      controller = request;
      try {
        const response = await fetch(url(), { method: 'GET', credentials: 'same-origin', cache: 'no-store', signal: request.signal });
        if (!response.ok) return;
        const sections = await response.json();
        const markup = sections['cart-icon-bubble'];
        if (typeof markup !== 'string' || !markup) return;
        const parsed = new DOMParser().parseFromString(markup, 'text/html');
        const inner = parsed.querySelector('.header__cart-inner');
        if (!inner || !active || requestVersion !== version) return;
        // Keep the link itself, keyboard handlers, focus and Rebuy drawer hooks intact.
        const link = document.querySelector('#cart-icon-bubble');
        if (link) link.innerHTML = inner.outerHTML;
      } catch { /* An aborted/failed read must not change the cart or disrupt the drawer. */ }
    }
    function schedule() {
      version += 1;
      clearTimeout(timer);
      controller?.abort();
      timer = setTimeout(() => render(version), delay);
    }
    function restore(event) {
      if (!active || (event.type === 'pageshow' && !event.persisted)) return;
      schedule();
      const cart = getCart();
      if (restoring || typeof cart?.fetchShopifyCart !== 'function') return;
      restoring = true;
      let finished = false;
      const finish = () => { if (finished) return; finished = true; restoring = false; if (active) schedule(); };
      try {
        const read = cart.fetchShopifyCart(finish);
        if (read?.then) read.then(finish, finish);
      } catch { finish(); }
    }
    function start() {
      if (listening) return;
      listening = true;
      events.forEach(name => document.addEventListener(name, schedule));
      window?.addEventListener('pageshow', restore);
      window?.addEventListener('popstate', restore);
    }
    function destroy() {
      active = false; version += 1; clearTimeout(timer); controller?.abort();
      events.forEach(name => document.removeEventListener(name, schedule));
      window?.removeEventListener('pageshow', restore);
      window?.removeEventListener('popstate', restore);
    }
    return { start, destroy, refresh: () => { version += 1; return render(version); } };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = createBridge;
  else if (!document.documentElement.dataset.dsCartHeaderSync) {
    document.documentElement.dataset.dsCartHeaderSync = 'ready';
    createBridge({ document, window, fetch: window.fetch.bind(window), DOMParser, location: window.location,
      cartURL: window.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`,
      setTimeout: window.setTimeout.bind(window), clearTimeout: window.clearTimeout.bind(window), AbortController }).start();
  }
}());
